// TODO: 讓 KNOWN_CONSUMABLES 回傳結果知道吃到是哪種 string

import { toUrlObjectOrNull } from '../transformer/url';

/**
 * 已知的可消費查詢參數常數
 */
export const KNOWN_CONSUMABLES = Object.freeze({
  SHARING_SEEK: '__handsup_sharing_seek',
});

/**
 * 從 URL 中提取指定的查詢參數並移除第一個匹配項
 * @param url - 要處理的 URL
 * @param name - 要提取的參數名稱
 * @returns 包含處理後的 URL 和提取的值
 * @example extract('https://example.com?a=1&target=ok&b=2', 'target')
 * // { url: 'https://example.com?a=1&b=2', val: 'ok' }
 */
export const extract = (url: string | URL, name: string) => {
  const u = toUrlObjectOrNull(String(url));
  if (!u) {
    return {
      val: undefined,
      url: String(url),
    };
  }

  const [firstValue, ...restValues] = u.searchParams.getAll(name);
  u.searchParams.delete(name);
  for (const restValue of restValues) {
    u.searchParams.append(name, restValue);
  }

  return {
    val: firstValue,
    url: u.href,
  };
};

/**
 * 從當前頁面 URL 中消費（提取並移除）指定的查詢參數
 * ⚠️ 此函式有副作用，會替換當前頁面的 location.href
 * @param name - 要消費的參數名稱
 * @returns 提取到的參數值
 */
export const consume = (name: string) => {
  const { val, url: newUrl } = extract(location.href, name);

  // NOTE: The following code will cause SecurityError in jest with JSDOM environment,
  // but it's ok in real runtime environment
  // ref: https://github.com/oblador/loki/issues/51#issuecomment-385312871
  // ref: https://jestjs.io/docs/configuration#testenvironmentoptions-object
  if (import.meta.env.VITE_APP_STAGE !== 'test') {
    history.replaceState(history.state, '', newUrl);
  }

  return val;
};
